import { ref } from "vue";
import { api } from "@/api/client.js";
import { readStorage, writeStorage, clearSession } from "@/utils/storage.js";

export function readUser() {
  return readStorage("userInfo", null);
}
export const user = ref(readUser());
export function isMerchant(member = user.value) {
  return Boolean(
    member &&
      (member.isMerchant ||
        ["merchant", "partner", "agent"].includes(String(member.role || ""))),
  );
}
export function saveUser(member) {
  if (!member?.id) return null;
  user.value = member;
  writeStorage("id", member.id);
  writeStorage("userInfo", member);
  if (isMerchant(member)) {
    localStorage.removeItem("wxfid");
    localStorage.removeItem("homeMerchant");
  }
  return member;
}
export async function refreshUser() {
  if (!readUser()?.id) return null;
  return saveUser(await api.member({}));
}
export function logout(router) {
  clearSession();
  writeStorage("codexLogoutRequireAuthConfirm", true);
  if (router) router.replace("/pages/home/login");
}
export function requireLogin(router) {
  if (readUser()?.id) return true;
  if (router)
    router.replace({
      path: "/pages/home/login",
      query: { redirect: router.currentRoute.value.fullPath },
    });
  return false;
}
window.addEventListener("session-cleared", () => {
  user.value = null;
});
window.addEventListener("storage", (event) => {
  if (event.key === "userInfo") user.value = readUser();
});
